import React from "react";
import { Link } from "react-router-dom";
import {
  FiFacebook,
  FiTwitter,
  FiInstagram,
  FiYoutube,
  FiMail,
  FiPhone,
  FiMapPin,
  FiSend,
} from "react-icons/fi";

import "../assets/css/footer.css";

function Footer() {
  return (
    <footer className="modern-footer">
      <div className="container">
        {/* --- Top Section: Newsletter --- */}
        {/* <div className="footer-newsletter row align-items-center">
          <div className="col-lg-6 mb-3 mb-lg-0">
            <h5 className="mb-1 fw-bold">Join Our Newsletter</h5>
            <p className="text-muted mb-0 small">Subscribe to get special offers, free giveaways, and once-in-a-lifetime deals.</p>
          </div>
          <div className="col-lg-6">
            <form className="newsletter-box">
              <input type="email" placeholder="Enter your email address" required />
              <button type="submit"><FiSend className="me-2" />Subscribe</button>
            </form>
          </div>
        </div> */}

        <div className="row g-4 footer-main">
          {/* Brand & Contact */}
          <div className="col-lg-4 col-md-6">
            <div className="footer-brand mb-4">
              <h3 className="fw-bold text-danger">SubCity<span>.</span></h3>
              <p className="text-muted small mt-3">
                Your one-stop destination for premium fashion, electronics, and home essentials. Quality products delivered to your doorstep.
              </p>
            </div>
            <div className="contact-info">
              <div className="d-flex align-items-center mb-2">
                <FiMapPin className="text-danger me-2" />
                <span className="small">Paliguri, Jagiroad, Morigaon, Assam Pin code 782410</span>
              </div>
              <div className="d-flex align-items-center mb-2">
                <FiPhone className="text-danger me-2" />
                <span className="small">+91 84730 63263</span>
              </div>
              <div className="d-flex align-items-center mb-2">
                <FiMail className="text-danger me-2" />
                <span className="small">support@subcity.com</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-lg-2 col-6">
            <h6 className="footer-heading">SHOPPING</h6>
            <ul className="footer-links">
              <li><Link to="/men">Men's Store</Link></li>
              <li><Link to="/women">Women's Store</Link></li>
              <li><Link to="/kids">Kids Collection</Link></li>
              <li><Link to="/electronics">Electronics</Link></li>
              <li><Link to="/offers">Special Offers</Link></li>
            </ul>
          </div>

          {/* Customer Service */}
          <div className="col-lg-2 col-6">
            <h6 className="footer-heading">HELP CENTER</h6>
            <ul className="footer-links">
              <li><Link to="/track-order">Track Order</Link></li>
              <li><Link to="/shipping">Shipping Policy</Link></li>
              <li><Link to="/returns">Return & Refund</Link></li>
              <li><Link to="/faq">FAQs</Link></li>
              <li><Link to="/contact">Contact Support</Link></li>
            </ul>
          </div>

          {/* Social & Payments */}
          <div className="col-lg-4 col-md-6">
            <h6 className="footer-heading">FOLLOW US</h6>
            <div className="social-icons mb-4">
              <a href="https://www.facebook.com/profile.php?id=100085867121280" target="_blank" className="facebook"><FiFacebook /></a>
              {/* <a href="#" className="twitter"><FiTwitter /></a> */}
              <a href="https://www.instagram.com/subcityinternational22/" target="_blank" className="instagram"><FiInstagram /></a>
              <a href="https://www.youtube.com/channel/UCiFGO2iZKtkBm9mKiDTIO2w/" target="_blank" className="youtube"><FiYoutube /></a>
            </div>
            <h6 className="footer-heading">SECURE PAYMENTS</h6>
            <div className="payment-methods">
              <img src="https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg" alt="Visa" />
              <img src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg" alt="Mastercard" />
              <img src="https://upload.wikimedia.org/wikipedia/commons/b/b5/PayPal.svg" alt="Paypal" />
              <img src="https://upload.wikimedia.org/wikipedia/commons/e/e1/UPI-Logo.png" alt="UPI" />
            </div>
          </div>
        </div>

        {/* --- Bottom Bar --- */}
        <div className="footer-bottom border-top pt-4 mt-5">
          <div className="row align-items-center">
            <div className="col-md-6 text-center text-md-start small text-muted">
              © 2026 SubCity India. Designed for the modern shopper.
            </div>
            <div className="col-md-6 text-center text-md-end mt-2 mt-md-0">
              <Link to="/privacy" className="small text-muted me-3 text-decoration-none">Privacy Policy</Link>
              <Link to="/terms" className="small text-muted text-decoration-none">Terms & Conditions</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;